import { render, staticRenderFns } from "./ModalRejectOrderAttachments.vue?vue&type=template&id=2865dcae&"
import script from "./ModalRejectOrderAttachments.vue?vue&type=script&lang=ts&"
export * from "./ModalRejectOrderAttachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports